import CustomLabel from "../../../../shapes/labels/CustomLabel";
import { MOVE_LABEL } from "../../../../tools/actions/ActionHelper";
import AbstractField from "../AbstractField";
import CustomLabelField from "./CustomLabelField";
import NewLabelButton from "./NewLabelButton";
import SpeciesLabelField from "./SpeciesLabelField";

export default class SpeciesLabelList extends AbstractField {
    rows = [];

    populate(element) {
        this.rows.map(row => row.delete());
        this.newLabelButton?.delete();
        this.sortable?.destroy();

        this.newLabelButton = new NewLabelButton(
            this.provider,
            this.newLabelContainer,
            element.labels,
            0,
            this.newLabelContainer
        );

        this.rows = element.labels.labels.map(label => {
            if (label instanceof CustomLabel) {
                return new CustomLabelField(this.provider, label, this.rowContainer);
            } else {
                return new SpeciesLabelField(this.provider, label, this.rowContainer);
            }
        });
        let action = null;
        this.sortable = Sortable.create(this.rowContainer.elt, {
            handle: '.move-icon',
            onChoose: (evt) => this.rows.map(r => r.drag()),
            onUnchoose: (evt) => this.rows.map(r => r.endDrag()),
            onStart: (evt) => {
                action = this.actions.new(MOVE_LABEL, element.labels, this.rows);
            },
            onEnd: (evt) => {
                action.finish(evt.oldIndex, evt.newIndex);
                action = null;
            },
        });
    }

    make() {
        this.field = this.p.createDiv().class('input-group');
        this.label = this.p.createElement('h3', 'Species/Labels')
            .parent(this.field)
            .class('input-label')
            .style('margin-top', '0px')
            .style('margin-bottom', '0px');
        this.newLabelContainer = this.p.createDiv()
            .parent(this.field);
        this.rowContainer = this.p.createDiv()
            .parent(this.field)
            .id('species-list');
        this.parentElement ? this.field.parent(this.parentElement) : null;
        this.initialized = true;
        return this;
    }

    reset() {
        this.rows.map(row => row.delete());
        this.rows = [];
    }
}
